import {
  createLessonClassConversation,
  createLessonClassConversationInvitation,
  fetchLessonClassConversationCounts,
  fetchLessonClassConversations,
} from "classroom/api/teacher";
import type { ClassroomConversationInvitationFormData } from "conversations/types";
import {
  requireConversationContext,
  useConversationRowList,
} from "conversations/composables/useConversationRowList";
import { defineStore } from "pinia";

/**
 * The Gesprekken tab of a lesgroep. The context is the schedule id, which is what decides
 * both the vak and the students — never the lesson class name, which its other subjects
 * share.
 *
 * Every endpoint here is class-scoped, so each fetcher runs the context through
 * `requireConversationContext` — see the mentorklas store for why the composable does not.
 */
export const useClassroomLessonClassConversationStore = defineStore(
  "classroomLessonClassConversation",
  () => {
    const list = useConversationRowList({
      fetchList: (params, schedule) =>
        fetchLessonClassConversations(
          requireConversationContext(schedule),
          params,
        ),
      fetchCounts: (params, schedule) =>
        fetchLessonClassConversationCounts(
          requireConversationContext(schedule),
          params,
        ),
      createNote: (formData, schedule) =>
        createLessonClassConversation(
          requireConversationContext(schedule),
          formData,
        ),
    });

    /** The classroom plan page's create — see the mentorklas store. */
    const createInvitation = (
      formData: ClassroomConversationInvitationFormData,
    ) =>
      createLessonClassConversationInvitation(
        requireConversationContext(list.context.value),
        formData,
      );

    return { ...list, createInvitation };
  },
);
